import React from 'react'
import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

const ModalRecover = ({
  show,
  handleCancel,
  handleConfirm,
  appendToDataMuTest
}) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.AbTest.ModalRecoverConfirmTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.AbTest.ModalRecoverConfirmDescr'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.AbTest.Recover' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      data-mu-test={`modal-recover-sending-${appendToDataMuTest}`}
    />
  )
}

ModalRecover.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  appendToDataMuTest: PropTypes.string
}

export default ModalRecover
